import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../NewsletterPage.css";  
import "../index.css";
import { FaHeart, FaSearch } from "react-icons/fa"; 
import UnauthorizedNavbar from "./unauthorizedNavbar";
import UnauthorizedFooter from "./unauthorizedFooter";

const BASE_URL = process.env.REACT_APP_BASE_URL;

  const token = window.sessionStorage.getItem("jwtToken");

const CategoryPage = () => {
    const { category } = useParams();
    const [newsletters, setNewsletters] = useState([]);
    const [likes, setLikes] = useState({});
    const [likedStatus, setLikedStatus] = useState({});
    const [searchTerm, setSearchTerm] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
           fetch(`${BASE_URL}/fetchNewsLetterAndBlogs`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                }
            })
            .then((response) => response.json())
            .then((data) => {
                if (Array.isArray(data)) {
                    const filteredData = data.filter(news => news.categories?.includes(category));
                    setNewsletters(filteredData);

                    const initialLikes = filteredData.reduce((acc, news) => {
                        acc[news.id] = news.likesCount || 0;
                        return acc;
                    }, {});
                    setLikes(initialLikes);
                }
            })
            .catch((error) => console.error("Error fetching data:", error));
    }, [category]);

    const handleLike = (id) => {
        const isLiked = likedStatus[id];
        const newLikeCount = isLiked ? likes[id] - 1 : likes[id] + 1;

        setLikes((prevLikes) => ({
            ...prevLikes,
            [id]: newLikeCount,
        }));

        setLikedStatus((prevStatus) => ({
            ...prevStatus,
            [id]: !isLiked,
        }));

        fetch(`${BASE_URL}/${id}/like`, { method: "POST" ,
            headers: {
                Authorization: `Bearer ${token}`
            }})
            .then((response) => response.json()) 
            .then((data) => {
                setLikes((prevLikes) => ({
                    ...prevLikes,
                    [id]: data.likesCount, 
                }));
            })
            .catch((error) => console.error("Error updating like count", error));
    };

    const handleRedirect = (news) => {
        const newState = { 
            title: news.text, 
            image: news.backgroundImage, 
            publishedDate: news.publishedDate,
            likes: likes[news.id] || 0,
            id: news.id,
            htmlPageLink : news.htmlPageLink
        };
        navigate('/newsLetterAndBlogsTemplate', { state: newState });
    };

    const filteredNewsletters = newsletters.filter(news =>
        news.text.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            <UnauthorizedNavbar />
            <div className="page-container" style={{ maxWidth: "100%", minHeight: "100vh", paddingBottom: "100px" }}>
                <h2 className="text-center" style={{ marginBottom: "20px" }}>{category}</h2>
                 <div className="search-container">
                    <div className="search-wrapper">
                        <FaSearch   style={{minHeight: "30px", marginLeft:"5px"}}/>
                            <input
                                type="text"
                                placeholder="Search using any keyword"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="search-input"
                                style={{border: "none"}}
                            />
                    </div>
                </div>

                <div className="site-container">
                    {filteredNewsletters.length === 0 ? (
                        <p className="text-center">No newsletters found.</p>
                    ) : (
                        filteredNewsletters.map((news) => (
                            <div key={news.id} className="blog-post-box">
                                <div className="image-container">
                                    <a href="#" onClick={() => handleRedirect(news)}>
                                        <img src={news.backgroundImage} alt="icon" className="image" />
                                    </a>
                                </div>
                                <div className="body">
                                    <h3>
                                        <a href="#" onClick={() => handleRedirect(news)} className="title-link">
                                            {news.text}
                                        </a>
                                    </h3>
                                    <div className="date-text">
                                        {new Date(news.publishedDate).toDateString()}
                                    </div>
                                    <button
                                        className={`like-button ${likedStatus[news.id] ? "liked" : "not-liked"}`}
                                        onClick={() => handleLike(news.id)}
                                    >
                                        <FaHeart
                                            className="like-icon"
                                            style={{
                                                color: likedStatus[news.id] ? "#ff4d4d" : "rgba(175, 162, 162, 0.36)",
                                            }}
                                        />
                                        {likes[news.id] || 0}
                                    </button>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
            <UnauthorizedFooter />
        </>
    );
};

export default CategoryPage;
